


































import mixins from '../../mixins';

export default mixins().extend({
  props: {
    value: { default: undefined, type: undefined },
    multiple: { default: false, type: Boolean },
    mandatory: { default: false, type: Boolean },
    iconLeft: { default: undefined, type: String },
    iconRight: { default: undefined, type: String },
    color: { default: undefined, type: String },
    tag: { default: 'div', type: String },
  },
  methods: {
    getLeftIcon(expanded: boolean) {
      if (this.iconLeft) {
        return this.iconLeft;
      }
      return expanded ? 'expand_less' : 'expand_more';
    },
  },
  data: () => ({
    isExpanded: false,
  }),
});
